<template>
  <div>
    {{ dateUtil(new Date(item.date), true, "FEHLER") }} Uhr
  </div>
</template>
<script>
import { dateUtil } from "../../api/api";
export default {
  props: ["item"],
  methods: {
    dateUtil,
  },
};
</script>
